import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { formatDate, getTableCellStickyStyle } from '../../../../utils'
import styles from './DateCell.module.scss'

const cx = classNames.bind(styles)

const DateCell = ({ item, previousColumn, rowOdd, stickyConfig, dateFormat }) => {
  return (
    <td
      className={cx('date-cell')}
      style={getTableCellStickyStyle(stickyConfig, false, rowOdd) || {}}
    >
      <p>{formatDate(item.date, dateFormat)}</p>
      {previousColumn && <p>{formatDate(item.previousDate, dateFormat)}</p>}
    </td>
  )
}

DateCell.propTypes = {
  item: PropTypes.shape().isRequired,
  previousColumn: PropTypes.bool.isRequired,
  rowOdd: PropTypes.bool,
  stickyConfig: PropTypes.shape({
    width: PropTypes.number,
    left: PropTypes.number,
    zIndex: PropTypes.number
  }),
  dateFormat: PropTypes.string
}

DateCell.defaultProps = {
  stickyConfig: null,
  dateFormat: null
}

export { DateCell }
